"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const entity_1 = require("../../type/entity");
const generateSortKey_1 = tslib_1.__importDefault(require("../helpers/generateSortKey"));
const getDefaultDueDate_1 = tslib_1.__importDefault(require("../helpers/getDefaultDueDate"));
function pathZeroState(content, user) {
    try {
        const currentDate = new Date().toISOString();
        const defaultDate = getDefaultDueDate_1.default();
        return {
            rootContentId_contentId: generateSortKey_1.default(content._id.toString(), content._id.toString()),
            companyId: user.companyId,
            userId: user.userId,
            contentId: content._id,
            contentType: entity_1.StateContentType.CURRICULUM_OFFER,
            completionStatus: entity_1.CompletionStatus.NOT_ATTEMPTED,
            successStatus: entity_1.SuccessStatus.NOT_APPLICABLE,
            scaledScore: 0,
            progressMeasure: 0,
            scaledProgressMeasure: 0,
            timeSpent: 0,
            submissionCount: 0,
            startedOn: defaultDate,
            lastAccessedOn: defaultDate,
            completedOn: defaultDate,
            createdAt: currentDate,
            updatedAt: currentDate,
            forceComplete: false,
            contentStatus: 'active',
            unitsCompleted: 0
        };
    }
    catch (error) {
        throw new Error('Error in sectionZeroState ' + error);
    }
}
exports.default = pathZeroState;
//# sourceMappingURL=pathZeroState.js.map